import { Content } from '@tiptap/core'
import { createContext, FC, useContext } from 'react'

type ThreadContextValue = {
  onSubmitComment: (content: Content) => void
  onResolve?: () => void
  onClose?: () => void
  onEditComment?: (id: string, content: Content) => void
  onDeleteComment?: (id: string) => void
  onDeleteThread?: () => void
  onMentionListOpenChange?: (isOpen: boolean) => void
}

const ThreadContext = createContext<ThreadContextValue | undefined>(undefined)

export const useThread = (): ThreadContextValue => {
  const context = useContext(ThreadContext)
  if (!context) {
    throw new Error('No ThreadContext.Provider found when calling useThread')
  }

  return context
}

type ThreadContextProps = ThreadContextValue

export const ThreadContextProvider: FC<
  React.PropsWithChildren<ThreadContextProps>
> = ({
  children,
  onSubmitComment,
  onResolve,
  onClose,
  onEditComment,
  onDeleteComment,
  onDeleteThread,
  onMentionListOpenChange,
}) => {
  return (
    <ThreadContext.Provider
      value={{
        onSubmitComment,
        onResolve,
        onClose,
        onEditComment,
        onDeleteComment,
        onDeleteThread,
        onMentionListOpenChange,
      }}
    >
      {children}
    </ThreadContext.Provider>
  )
}
